import * as React from 'react';

import {
    useMediaQuery
} from '@mui/material'
import { useNavigate } from 'react-router-dom';
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import WhatsAppIcon from '@mui/icons-material/WhatsApp';

import EnvelopamentoWeb from '../../../../assets/images/nossosProdutosImages/envelopamento_webv2.webp';
import BackBusWeb from '../../../../assets/images/nossosProdutosImages/backbus_webv2.webp';
import BackseatWeb from '../../../../assets/images/nossosProdutosImages/backseat_webv2.webp';

import { BaseComp, BaseContent, TextBody, TextContent, TextTitle, DefaultBox, ImageContent, Img, ImageBox, SidebySideContent, ContactConsultant } from './styles';
import { useRef, useState } from 'react';
import { useIntersection } from 'react-use';

interface INavBar {

}



const NossosProdutos: React.FC<INavBar> = () => {
    const navigate = useNavigate();
    const Whatsap = 'https://api.whatsapp.com/send/?phone=5531982213102&text&type=phone_number&app_absent=0';

    const matches = useMediaQuery('(max-width:800px)');
        const swiperRef = useRef<any>(null);

    const carouselRef = useRef<HTMLDivElement>(null);

    const [isVisible, setIsVisible] = useState(false);

    const intersection = useIntersection(carouselRef, {
    root: null,
    rootMargin: '200px', // Ativa 200px antes de entrar no viewport
    threshold: 0.1, // Ativa quando 10% do elemento está visível
    });

    React.useEffect(() => {
    if (intersection?.isIntersecting) {
      setIsVisible(true);
      if (swiperRef.current) {
        swiperRef.current.autoplay?.start(); // Inicia o autoplay
      }
    } else {
      setIsVisible(false);
      if (swiperRef.current) {
        swiperRef.current.autoplay?.stop(); // Para o autoplay
      }
    }
  }, [intersection]);

    const dadosWeb = [
        {image:EnvelopamentoWeb, text: 'ENVELOPAMENTO WEB'},
        {image:BackBusWeb, text: 'BACKBUS WEB'},
        {image:BackseatWeb, text: 'BACKSEAT WEB'},
    ]

    const handleWhatsAppClick = () => {
        const url = `${Whatsap}`;
        window.open(url, '_blank');
    };


    return (
        <BaseComp id='prod'>
            <BaseContent>
                <SidebySideContent>
                    <TextContent>
                        <TextBody>
                            <TextTitle>
                                <h1>NOSSOS PRODUTOS</h1>
                            </TextTitle>
                            <p>
                                Circulamos por toda Belo Horizonte, incluindo Centro e Hipercentro da cidade. Além disso, somos a única opção de mídia circulante na Av. do Contorno!
                            </p>
                            <ContactConsultant onClick={handleWhatsAppClick}>
                                <WhatsAppIcon sx={{ width: "1.5em", height: "1.5em", color: "white" }}/>
                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    <p style={{ marginBottom: "-5px" }}>FALE COM UM</p>
                                    <p  style={{ marginTop: "-5px" }}>CONSULTOR</p>
                                </div>
                                
                            </ContactConsultant>
                        </TextBody>
                    </TextContent>
                    <ImageContent
                        ref={carouselRef}
                    >
                        {matches ? (
                            <Swiper
                                modules={[Navigation, Pagination, Scrollbar, A11y, Autoplay]}
                                spaceBetween={2}
                                slidesPerView={1}
                                pagination={{
                                    clickable: true,
                                }}
                                onSwiper={(swiper: any) => {
                                    swiperRef.current = swiper;
                                    if (isVisible) {
                                    swiper.autoplay?.start();
                                    }
                                }}
                                style={{
                                    display: 'flex',
                                    textAlign: 'center',
                                    maxWidth: '100%',
                                    width: "250px",
                                    height: '350px',
                                }}
                            >
                                {dadosWeb.map((data:any) => (
                                    <SwiperSlide
                                        style={{
                                            width: matches ? '50%' : '70%',
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            color: "var(--purple)",
                                            fontWeight: "bold"
                                        }}
                                    >
                                        <img src={data?.image} width="250px"/>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        ) : (
                            <Swiper
                                modules={[Navigation, Pagination, Scrollbar, A11y, Autoplay]}
                                spaceBetween={2}
                                slidesPerView={1}
                                pagination={{
                                    clickable: true,
                                }}
                                onSwiper={(swiper: any) => {
                                    swiperRef.current = swiper;
                                    if (isVisible) {
                                    swiper.autoplay?.start();
                                    }
                                }}
                                style={{
                                    display: 'flex',
                                    textAlign: 'center',
                                    justifyContent: 'center',
                                    maxWidth: '100%',
                                    width: "300px",
                                    height: '350px',
                                }}
                            >
                                {dadosWeb.map((data:any) => (
                                    <SwiperSlide
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            color: "var(--purple)",
                                            fontWeight: "bold",
                                            marginBottom: "10px",

                                        }}
                                    >
                                        <img src={data?.image} width="250px" />
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        )}
                            
                    </ImageContent>
                </SidebySideContent>
            </BaseContent>
        </BaseComp>
    );
}

export { NossosProdutos }